export const ENV_FLAGS = [
  'IVCO_49_MOVE_IV_TO_MOBILE',
  'IT_4334_KIOSKO_MVP',
  'UPSELLING_TOP_OFFERS',
  'POSTHOG_TRACKING',
  'IC_PAYMENT_FEATURE',
  'IT_4595_GUIDEBOOKS_REDESING',
  'IT_5024_GUIDEBOOKS_PDF_HTML_SUPPORT',
  'FEEDBACK_MODAL_ENABLED',
] as const;
